import { POST_SSO_FAIL, POST_SSO_START, POST_SSO_SUCCESS } from './constants';

import { API_URL } from '@shared/constants/config';
import { POST, REST_API } from '@shared/constants/rest-api';

const headers = {
  Accept: '*/*',
  'Content-Type': 'application/json',
};

export const postSso = (body, onSuccess, onError) => ({
  type: REST_API,
  method: POST,
  url: `${API_URL}/login/sap`,
  headers: {
    ...headers,
    Authorization: localStorage.getItem('refreshToken'),
  },
  body,
  types: [POST_SSO_START, POST_SSO_SUCCESS, POST_SSO_FAIL],
  onSuccess,
  onError,
});
